import { Box, Stack } from "@mui/material";
import { ReactNode } from "react";

import PageContainer from "./PageContainer";

const APPrintablePage = ({
  topContent,
  bottomContent,
}: {
  topContent: ReactNode;
  bottomContent: ReactNode;
}) => {
  return (
    <PageContainer loading={false} size="full">
      <Stack spacing={4}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box>{topContent}</Box>
          <Box>
            <Box
              component="img"
              sx={{ height: 64, display: "flex" }}
              src="/auto-ux.svg"
            ></Box>
          </Box>
        </Box>
        <Box>{bottomContent}</Box>
      </Stack>
    </PageContainer>
  );
};

export default APPrintablePage;
